import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/plan/license.plan.query.gql"
import type {
  LicensePlansQuery,
  LicensePlansQueryVariables,
} from "@/v2-backoffice-client/license/plan/__types__/license.plan.query"

type Options = QueryHookOptions<LicensePlansQuery, LicensePlansQueryVariables>

export function useLicensePlansQuery(options?: Options) {
  return useQuery<LicensePlansQuery, LicensePlansQueryVariables>(query, options)
}
